import { render, staticRenderFns } from "./orderStatus.vue?vue&type=template&id=a50439e6&scoped=true&"
import script from "./orderStatus.vue?vue&type=script&lang=js&"
export * from "./orderStatus.vue?vue&type=script&lang=js&"
import style0 from "./orderStatus.vue?vue&type=style&index=0&id=a50439e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50439e6",
  null
  
)

export default component.exports